import {
  Badge,
  Button,
  EmptyState,
  IconButton,
  InfiniteScrollTrigger,
  NotificationList,
  NotificationListItem,
  NotificationListItemSkeleton,
  NotificationsIcon,
  Popover,
  SidePanel,
  Stack,
  Typography,
} from '@all-manager/design-system-v2';
import { useNotificationsBell } from './useNotificationsBell';

const SKELETON_ROWS = [0, 1, 2];
const MAX_BADGE_COUNT = 99;

export default function NotificationsBell() {
  const bell = useNotificationsBell();

  const markAllButton = bell.unreadCount > 0 ? (
    <Button variant="text" size="small" onClick={bell.handleMarkAllRead}>
      Tout marquer comme lu
    </Button>
  ) : null;

  // Shared body (loading / empty / list) of the desktop popover and the phone panel.
  const content = bell.isLoading ? (
    <NotificationList aria-label="Notifications" aria-busy>
      {SKELETON_ROWS.map((row) => <NotificationListItemSkeleton key={row} />)}
    </NotificationList>
  ) : bell.items.length === 0 ? (
    <EmptyState
      title="Aucune notification"
      subtitle="Les rappels arrivant à échéance et les nouveaux événements de la copropriété s'afficheront ici."
    />
  ) : (
    <Stack spacing={1}>
      <NotificationList aria-label="Notifications">
        {bell.items.map((item) => (
          <NotificationListItem
            key={item.notification.id}
            message={item.message}
            date={item.relativeDate}
            dateTime={item.notification.created_at}
            unread={!item.notification.read_at}
            onClick={() => bell.handleNotificationClick(item.notification)}
          />
        ))}
      </NotificationList>
      <InfiniteScrollTrigger
        hasMore={bell.hasMore}
        isLoading={bell.isLoadingMore}
        isError={bell.isLoadMoreError}
        onLoadMore={bell.handleLoadMore}
        label="Notifications plus anciennes"
      />
    </Stack>
  );

  return (
    <>
      <IconButton tooltip="Notifications" aria-label={bell.buttonLabel} onClick={bell.handleOpen}>
        <Badge badgeContent={bell.unreadCount} max={MAX_BADGE_COUNT} color="primary">
          <NotificationsIcon />
        </Badge>
      </IconButton>

      {bell.isPhone ? (
        <SidePanel
          open={bell.isOpen}
          onClose={bell.handleClose}
          closeLabel="Fermer les notifications"
          title="Notifications"
          footer={markAllButton ?? undefined}
        >
          {content}
        </SidePanel>
      ) : (
        <Popover
          open={bell.isOpen}
          anchorEl={bell.anchorEl}
          onClose={bell.handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          aria-label="Notifications"
        >
          <Stack spacing={1}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
              <Typography variant="h6">Notifications</Typography>
              {markAllButton}
            </Stack>
            {content}
          </Stack>
        </Popover>
      )}
    </>
  );
}
